import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const laureateBlocks = document.querySelectorAll('.laureates');

  if (!laureateBlocks.length) return;

  laureateBlocks.forEach((laureateBlock) => {
    const thumbsEL = laureateBlock.querySelector(
      '.laureates__carousel-thumbnails'
    );
    const mainEL = laureateBlock.querySelector('.laureates__main-carousel');

    if (!thumbsEL || !mainEL) return;

    new Swiper(thumbsEL, {
      slidesPerView: 2,
      spaceBetween: 30,
      loop: true,
      initialSlide: 1,
      navigation: {
        prevEl: laureateBlock.querySelector('.swiper-button-prev'),
        nextEl: laureateBlock.querySelector('.swiper-button-next'),
      },
    });

    new Swiper(mainEL, {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      navigation: {
        prevEl: laureateBlock.querySelector('.swiper-button-prev'),
        nextEl: laureateBlock.querySelector('.swiper-button-next'),
      },
    });
  });
});
